import { Row, Col } from 'react-bootstrap'
import { ICustomColumn, IPageProps, IRootState } from 'types'
import { PageHeader, ReturnButton } from 'components'
import { V1ApiReportsClient } from 'core/http-common'
import { OpenInvoiceDto } from '@v1ReportsApi'
import { useEffect, useState } from 'react'
import toast from 'core/toast'
import { useSelector } from 'react-redux'
import { DatePickerChangeEvent, DatePicker } from '@progress/kendo-react-dateinputs'
import { Label } from '@progress/kendo-react-labels'
import { Skeleton } from '@progress/kendo-react-indicators'
import SAGrid from 'components/Grid/SAGrid'
import { DropdownFilterCell } from 'components/Dropdowns/DropdownFilterCell'
import { GridFilterCellProps } from '@progress/kendo-react-grid'

const OpenInvoicesPage = ({ title }: IPageProps) => {
    const [endDate, setEndDate] = useState<Date>(new Date())
    const todaysDate: Date = new Date()

    const [invoices, setInvoices] = useState<Array<OpenInvoiceDto>>([])

    const [loaded, setLoaded] = useState(false)

    const handleDateChange = (event: DatePickerChangeEvent) => {

        if (event.value) {
            setEndDate(event.value)
        }
    }
    const fetch = async () => {
        try {
            const result = await V1ApiReportsClient.getOpenInvoicesReport(endDate)
            setInvoices(result.data)
            setLoaded(true)
        }
        catch (e) {
            toast.responseErrors(e)
        }
    }

    useEffect(() => {
        if (endDate.getFullYear() > 1900)
            fetch()
    }, [endDate])


    const categories =
        [
            'By Mail',
            'Credit Card',
            'ACH'
        ]

    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const CategoryFilterCell: any = (props: GridFilterCellProps) => (
        <DropdownFilterCell
            {...props}
            data={categories}
            defaultItem={'Select'}
        />
    )


    const openInvoicesColumns: ICustomColumn[] = [
        { field: 'dealerInvoice_ID', title: 'Dealer Invoice ID' },
        { field: 'id', title: 'ID' },
        { field: 'name', title: 'Name' },
        { field: 'productName', title: 'Product Name' },
        { field: 'productAmount', title: 'Product Amount', filterType: 'numeric' },
        { field: 'paymentMethod', title: 'Payment Method', filterCell: CategoryFilterCell },
        { field: 'invoiceDate', title: 'Invoice Date', format: '{0:d}', filterType: 'date' },
        { field: 'dueDate', title: 'Due Date', format: '{0:d}', filterType: 'date' },
        { field: 'invoiceAmount', title: 'Invoice Amount', format: '{0:C0}', filterType: 'numeric' },
        { field: 'totalAmountDue', title: 'Total Amount Due', format: '{0:C0}', filterType: 'numeric' },
    ]
    return (
        <div id='OpenInvoicesPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/reports' />
            </PageHeader>

            <Row>
                <Col>
                    <div className='bg-light border rounded p-3 shadow-sm mb-3'>
                        <form className='k-form' onSubmit={(e) => e.preventDefault()}>
                            <fieldset className='col-md-3'>
                                <Label>End Date:</Label>
                                <DatePicker defaultValue={endDate} value={endDate} max={todaysDate} onChange={handleDateChange} defaultShow={false} />
                            </fieldset>
                        </form>
                    </div>
                    {!loaded ? <Skeleton shape='rectangle' style={{ width: '100%', height: '500px' }} animation={{ type: 'pulse' }} />
                        :
                        <SAGrid
                            features={
                                {
                                    pageable: true,
                                    sortable: true,
                                    filterable: true,
                                    exportToExcel: true,
                                    exportToPDF: false,
                                    reorderColumns: true
                                }
                            }
                            data={invoices}
                            columns={openInvoicesColumns}
                            defaultSort={[{ field: 'productName', dir: 'asc' }]}
                        />
                    }
                </Col>
            </Row>
        </div>
    )
}
export default OpenInvoicesPage